<template>
  <Modal
    v-model="_value"
    width="600"
    title="查看/修改用户分组信息"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="loginForm" :model="userGroupInfo" :rules="rules" style="display: inline;">
      <FormItem prop="name">
        <label style="display: inline-block; width: 80px;">用户分组名称</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="userGroupInfo.name"
               placeholder="请输入用户分组名称">
        </Input>
      </FormItem>
      <FormItem prop="telephone">
        <label style="display: inline-block; width: 80px;">联系电话</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="userGroupInfo.telephone"
               placeholder="请输入联系电话">
        </Input>
      </FormItem>
      <FormItem prop="address">
        <label style="display: inline-block; width: 80px;">联系地址</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="userGroupInfo.address"
               placeholder="请输入联系地址">
        </Input>
      </FormItem>
      <FormItem prop="contactName">
        <label style="display: inline-block; width: 80px;">联系人姓名</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="userGroupInfo.contactName"
               placeholder="请输入联系人姓名">
        </Input>
      </FormItem>
      <FormItem prop="contactPhoneNum">
        <label style="display: inline-block; width: 80px;">联系人手机</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="userGroupInfo.contactPhoneNum"
               placeholder="请输入联系人手机">
        </Input>
      </FormItem>
      <FormItem prop="parentUserGroupId">
        <label style="display: inline-block; width: 80px;">父级用户分组</label>
        <Select :disabled="!modify"
                style="display: inline-block; width: 200px;"
                v-model="userGroupInfo.parentUserGroupId"
                filterable
                clearable
                remote
                :remote-method="searchGroupValue"
                :loading="searchGroupLoading">
          <Option v-for="(option, index) in searchGroupList" :value="option.id" :key="option.id">{{option.name}}</Option>
        </Select>
        <Button :disabled="!modify" type="primary" style="display: inline-block; margin-left: 5px;" @click="onClear">清空</Button>
      </FormItem>
      <FormItem prop="description">
        <label style="display: inline-block; width: 80px;">描述</label>
        <Input style="display: inline-block; width: 400px;" :disabled="!modify" type="textarea"
               v-model="userGroupInfo.description" placeholder="请输入描述">
        </Input>
      </FormItem>
    </Form>
    <Row style="text-align: right;">
      <i-switch v-model="modify" @on-change="modifyChange" size="large">
        <span slot="open">保存</span>
        <span slot="close">修改</span>
      </i-switch>
    </Row>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'UserDetailModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      parentUserGroupId: null,
      nameRules: {
        type: Array,
        default: () => {
          return [
            {required: true, message: '用户分组名不能为空', trigger: 'blur'}
          ]
        }
      }
    },
    data() {
      return {
        modify: false,
        searchGroupValue:null,
        searchGroupLoading: false,
        searchGroupList: [],
        userGroupInfo: {
          id: null,
          name:null,
          telephone:null,
          description:null,
          address:null,
          contactName:null,
          contactPhoneNum:null,
          parentUserGroupId:null,
          parentUserGroup:null
        }
      }
    },
    methods: {
      ...mapActions([
        'UserGroupServ_GetDetail',
        'UserGroupServ_ModifyObj',
        'UserGroupServ_SearchByName'
      ]),
      onClear(){
        this.userGroupInfo.parentUserGroupId = null
      },
      searchGroup(input) {
        this.searchGroupLoading = true
        if (!input || input.length <= 0) {
          this.searchGroupList = []
          this.searchGroupLoading = false
        } else {
          store.dispatch('UserGroupServ_SearchByName', {
            params: {name: input},
            urlparams: null
          }).then(() => {
            this.searchGroupList = store.getters.get_UserGroup_SearchByNameResult ? store.getters.get_UserGroup_SearchByNameResult : []
            this.searchGroupLoading = false
          }).catch(err => {
            this.searchGroupLoading = false
          })
        }
      },
      modifyChange(status) {
        if (status === false) {
          this.$Modal.confirm({
            title: '确认修改用户分组',
            content: '<p>确认修改用户分组</p>',
            onOk: () => {
              store.dispatch('UserGroupServ_ModifyObj', {
                params: this.userGroupInfo
              }).then(() => {
                this.$Message.success('修改成功')
                this.$emit('on-success')
              }).catch(err => {
                this.$Message.error(err)
                this.$emit('on-fail')
              });
            },
            onCancel: () => {
              let userId = this._initValue
              store.dispatch('UserGroupServ_GetDetail', {
                params: {id: userId}
              }).then(() => {
                this.userGroupInfo = store.getters.get_UserGroup_GetDetailResult;
              }).catch(err => {
                this.$Message.error(err)
              })
            }
          });
        }
      },
      visibleChange(val) {
        if (val) {
          this.modify = false
          this.userGroupInfo.id = null
          this.userGroupInfo.name = null
          this.userGroupInfo.telephone = null
          this.userGroupInfo.description = null
          this.userGroupInfo.address = null
          this.userGroupInfo.contactName = null
          this.userGroupInfo.contactPhoneNum = null
          this.userGroupInfo.parentUserGroupId = this.parentUserGroupId
          let userGroupId = this._initValue
          if (userGroupId) {
            store.dispatch('UserGroupServ_GetDetail', {
              params: {id: userGroupId}
            }).then(() => {
              let userGroupInfo = store.getters.get_UserGroup_GetDetailResult
              if(userGroupInfo.parentUserGroup){
                this.searchGroupList = []
                this.searchGroupList.push(userGroupInfo.parentUserGroup)
                this.searchGroupValue = this.searchGroup

                store.dispatch('UserGroupServ_GetDetail', {
                  params: {id: userGroupId}
                }).then(() => {
                  this.userGroupInfo = store.getters.get_UserGroup_GetDetailResult;
                }).catch(err => {
                  this.$Message.error(err)
                })
              }else{
                this.userGroupInfo = userGroupInfo
              }
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _parentUserGroupId: {
        get() {
          return this.parentUserGroupId
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules() {
        return {
          name: this.nameRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
